import { Injectable } from '@angular/core';
import countries from '../../assets/country/iso3166-1';
import states from '../../assets/country/iso3166-2';

export interface StateInfo {
  code: string;
  name: string;
  type: string;
}


export interface CountryInfo {
  code: string;
  name: string;
  states: StateInfo[];
}

@Injectable({
  providedIn: 'root',
})
export class FormdataService {
  public countries: CountryInfo[];

  constructor() {
    this.countries = countries.map(d => ({
      code: d.alpha_2,
      name: d.name,
      states: states.filter(s => s.code.substring(0, 2) === d.alpha_2).map(s => ({ code: s.code.substring(3), name: s.name, type: s.type })),
    }));
  }

  public currencies = ['USD', 'CAD', 'EUR', 'GBP'];

  public inco_terms = ['EXW', 'FCA', 'FAS', 'FOB', 'CFR', 'CIF', 'CPT', 'CIP', 'DAT', 'DAP', 'DDP'];
}
